import axios from 'axios';
import {BaseResponse} from "../BaseResponse";


export async function updateAwsMqttSubList() {
    const response = await axios.put<BaseResponse<boolean>>(`/situationRoom/updateSub`)

    return response.data
}